// extracted by mini-css-extract-plugin
module.exports = {"form":"recentTimeDrugCollectionEfforts_form__eZHmY","content":"recentTimeDrugCollectionEfforts_content__3gs8y","contentMain":"recentTimeDrugCollectionEfforts_contentMain__3n0ZI"};